import { Injectable } from '@angular/core';
import { StateCreator, StoreApi } from 'zustand/vanilla';
import { ClothingApiService } from '../../api/clothing-api.service';
import { GetClothingOutput } from '../../api/clothing-api.types';
import { NzMessageService } from 'ng-zorro-antd/message';
import { firstValueFrom } from 'rxjs';

export interface ClothingStoreState {
  activeClothing: GetClothingOutput | null;
  activeClothingList: GetClothingOutput[] | [];
}

export interface ClothingStoreSlice {
  clothing: ClothingStoreState;
}

export interface ClothingStoreActions {
  setActiveClothing: (id: number) => Promise<void>;
  setActiveClothingList: () => Promise<void>;
  reset: () => void;
}

const initialClothingStoreState: ClothingStoreState = {
  activeClothing: null,
  activeClothingList: [],
};

@Injectable()
export class ClothingStoreService {
  private slice: StateCreator<ClothingStoreSlice>;
  private actions: (
    store: StoreApi<ClothingStoreSlice>,
  ) => ClothingStoreActions;

  constructor(
    ClothingApiService: ClothingApiService,
    message: NzMessageService,
  ) {
    this.slice = () => ({
      clothing: initialClothingStoreState,
    });
    this.actions = (store) => ({
      async setActiveClothing(id): Promise<void> {
        const activeClothing = await ClothingApiService.getClothing(id);

        store.setState((state) => ({
          clothing: { ...state.clothing, activeClothing },
        }));
      },

      async setActiveClothingList(): Promise<void> {
        try {
          const activeClothingList = await firstValueFrom(
            ClothingApiService.getAllClothing({}),
          );

          store.setState((state) => ({
            clothing: { ...state.clothing, activeClothingList },
          }));
        } catch {
          message.error(
            'Etwas beim Laden der Kleidung ist etwas schiefgelaufen.',
          );
        }
      },

      reset() {
        store.setState({ clothing: initialClothingStoreState });
      },
    });
  }

  getSlice() {
    return this.slice;
  }

  getActions() {
    return this.actions;
  }
}
